import {componentStyle, seniorCfg} from '../common/common'
import {BASE_ECHARTS_SELECT, DEFAULT_TOOLTIP} from '@/views/chart/chart/chart'
import {hexColorToRGBA} from "@/views/chart/chart/util";
import {valueFormatterWithoutSuffix} from "@/views/chart/chart/formatter";
import isNumber from 'lodash/isNumber'

/**
 * 收入对比柱状图视图专用
 * @author huangsinan
 */

// 上升图标
const riseSVG = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="12" viewBox="0 0 20 12" fill="none"><path id="Path" fill-rule="evenodd" style="fill:#A5B557" transform="translate(0 0)  rotate(0 10 6)" opacity="1" d="M1.41 12L0 10.59L7.41 3.17L11.41 7.17L16.29 2.29L14 0L20 0L20 6L17.71 3.71L11.41 10L7.41 6L1.41 12Z" /></svg>'
// 下降图标
const declineSVG = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="12" viewBox="0 0 20 12" fill="none"><path id="Path" fill-rule="evenodd" style="fill:#D05E5E" transform="translate(0 0)  rotate(0 10 6)" opacity="1" d="M0 1.41L1.41 0L7.41 6L11.41 2L17.71 8.29L20 6L20 12L14 12L16.29 9.71L11.41 4.83L7.41 8.83L0 1.41Z" /></svg>'
// 柱状图标记点图片
const markPointImg = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAK9SURBVFiF3dk/T9tQFIfh99zCRuawtAsMsCBTuvIB2MhIhe0tqHRjY6tYWDtVBMRgpxJj8h0YulQkYilCYikgwcLEBuR0sEMTN07iPySovym6vrEfxb62z4mQIgrStO0VEVlG1VKRWQNFhYLCk8AdcAWcq+qJihy/9/0faY4lSSafuu5Sq9Uqi8iaQiHhsS4ROUL10PL981yBP113ZkL1C7CeENU7qvuI7Fi+fz1o6kBgw3E2Bb4Ck7ng/ubeqG4tVKsH/Sb1BTZsuyIi5XxdUYHsWZ73KXZz3Iam69ZQXX0ZVVQhdcvzSj039RocKe5Z0htpogMN266MHAegutqw7Up0uAvYcJzNF7/m+kREyg3H2ewaa38IbyW/yH+1Js3Do8j8B8+7AJhoj4b3udS4me1tpubmusYudne5PztLuqvJ0GJDeIpPXXeJvG7C+WQ9NAXAVqs1tusuLm2TURARWRs3KJrweS+madsrKR78Lx6FQtO2V4yILI8bExcRWTaoWuOGxEbVMioyO25HXFRk1hgojhsSFwNF8xoXSDsKBWk4zqPAm2G+MF0qUVzN5z3itl7nplYbBHwyYYEzVG5qNW7r9ZHgAATuDEH1NXSyIofFhbkywNAVVjtpkQlxAOdGVU8SH4nkyBQ4VPXEqMhxUlw7wyLT4ABU5FgAmo7zG3ibeA9h+q3utDjg0vL9d8Erv8hRWhzE/5IZcM+mAKh6mJ4XJIrMhOswPdckTduukEPBNF0KKseMuH2rWt2AjpoEkR3gIzCVBZgJFuQ+tAAdZafl+9dGdSvr3rPGqG51NpW66uKFavUAkb3Rs8KI7EWbSa++9fHqm0f/9GbasTyvpKr7L6cKE7TfeuKgDxBgsVrdUPgMPOQOCxqY5X69QRgABFj0/W+PIvPA99xowZmZG9Rdhf+liR7NKP+G+AMG6Vf9YMKdIgAAAABJRU5ErkJggg=='

export function baseBarOption(chart_option, chart) {
// 处理shape attr
  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
  }

  // 处理自定义组件样式
  let customStyle = {}
  if (chart.customStyle) {
    customStyle = JSON.parse(chart.customStyle)
    if (customStyle.xAxis) {
      chart_option.xAxis.inverse = customStyle.xAxis.inverse
    }
    if (customStyle.yAxis) {
      chart_option.yAxis.inverse = customStyle.yAxis.inverse
    }
  }

  // 处理data
  if (chart.data) {
    chart_option.title.text = chart.title
    // 横轴固定为月份
    chart_option.xAxis.data = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    // chart.data.series 只能传一组，和 chart.data.x 一一对应
    const series = chart.data.series[0] || []
    formatValue(series, chart)

    const map = new Map()
    let thisYear = 2022, lastYear = 2021;
    // chart.data.x 传入的值必须是数据对应的年月，格式为‘2022\n02’或‘2022-02’
    chart.data.x.forEach((item, index) => {
      let split = item.split("\n");
      if (split.length < 2) {
        split = item.split("-")
      }
      const year = parseInt(split[0]), month = parseInt(split[1])
      let arr = map.get(year)
      if (!Array.isArray(arr)) {
        arr = new Array(12).fill(null)
      }
      arr[month] = series.data[index]
      map.set(year, arr)
    })

    // 插入模拟数据
    if (!map.has(2021)) {
      map.set(2021, [13.4, 23.43, 3.1, null, 1.21, 13.41, 6.81, null, 2.45, 3.56, 5.12, 1.23])
    }

    const thisYearData = map.get(thisYear) || []
    const lastYearData = map.get(lastYear) || []
    // 计算后同比与环比数据
    const yoyData = new Array(12).fill("-")
    const qoqData = new Array(12).fill("-")
    for (let i = 0; i < 12; i++) {
      // 今年本月份的数据值
      let thisMonthValue = thisYearData[i];
      // 今年上月的数据值
      let lastMonthValue = i === 0 ? lastYearData[11] : thisYearData[i - 1]
      // 去年同月份的数据值
      let lastYearMonthValue = lastYearData[i]
      if (thisMonthValue !== null && typeof thisMonthValue == "object") {
        thisMonthValue = parseFloat(thisMonthValue.value)
      }
      if (lastMonthValue !== null && typeof lastMonthValue == "object") {
        lastMonthValue = parseFloat(lastMonthValue.value)
      }
      if (lastYearMonthValue !== null && typeof lastYearMonthValue == "object") {
        lastYearMonthValue = parseFloat(lastYearMonthValue.value)
      }
      // 计算同比数据
      if (isNumber(thisMonthValue) && isNumber(lastYearMonthValue)) {
        yoyData[i] = (thisMonthValue - lastYearMonthValue) / lastYearMonthValue
      }
      // 计算环比数据
      if (isNumber(thisMonthValue) && isNumber(lastMonthValue)) {
        qoqData[i] = (thisMonthValue - lastMonthValue) / lastMonthValue
      }
    }
    console.log('bar3 data', thisYearData, lastYearData, yoyData, qoqData)

    const thisYearSerial = buildSeries(customAttr, thisYearData, thisYear + '年', 0)
    thisYearSerial.markPoint = {
      data: [{
        type: 'min',
        label: {color: '#D05E5E', offset: [0, -15]},
        symbolOffset: [0, '-50%'],
        symbolSize: 20,
        symbol: markPointImg
      }]
    }
    chart_option.series.push(thisYearSerial)
    chart_option.series.push(buildSeries(customAttr, lastYearData, lastYear + '年', 1))

    // tooltip
    chart_option.tooltip.formatter = (params) => {
      let title, thisMonthStr, lastMonthStr, yoyStr, qoqStr;
      let thisMonth, lastYearMonth
      if (Array.isArray(params)) {
        thisMonth = params[0]
        if (params.length > 1) {
          lastYearMonth = params[1]
          lastMonthStr = `${lastYearMonth['marker']}\t${lastYearMonth['seriesName']}\t${lastYearMonth['value'] || '-'}<br/>`

          const yoyValue = yoyData[thisMonth["dataIndex"]]
          yoyStr = `<b>同比</b>\t`
          if (isNumber(yoyValue)) {
            yoyStr += `<span style="color:${yoyValue < 0 ? '#D05E5E' : '#A5B557'}">
                        <span style="margin-right: 4px;">${yoyValue < 0 ? declineSVG : riseSVG}</span>${toAbsPercent(yoyValue)}
                       </span><br/>`
          } else {
            yoyStr += '-<br/>'
          }

          const qoqValue = qoqData[thisMonth["dataIndex"]]
          qoqStr = `<b>环比</b>\t`
          if (isNumber(qoqValue)) {
            qoqStr += `<span style="color:${qoqValue < 0 ? '#D05E5E' : '#A5B557'}">
                        <span style="margin-right: 4px;">${qoqValue < 0 ? declineSVG : riseSVG}</span>${toAbsPercent(qoqValue)}
                       </span><br/>`
          } else {
            qoqStr += '-<br/>'
          }
        }
      } else {
        thisMonth = params
      }

      title = `<b>${thisMonth['axisValueLabel']}</b><br/>`
      thisMonthStr = `${thisMonth['marker']}\t${thisMonth['seriesName']}\t${thisMonth['value'] || '-'}<br/>`
      return `${title}${thisMonthStr}${lastMonthStr}${yoyStr}${qoqStr}`
    }
  }

  componentStyle(chart_option, chart)
  seniorCfg(chart_option, chart)
  return chart_option
}

/**
 * 取数值的绝对值并转换为百分号形式
 * @param value 数值原值
 * @param fixed 保留的小数点位数
 * @returns {string} 格式化后的结果
 */
const toAbsPercent = (value, fixed = 2) => {
  if (isNumber(value)) {
    return (Math.abs(value) * 100).toFixed(fixed) + '%'
  }
  return '-'
}

/**
 * 构造系列数据值对象
 * @param customAttr
 * @param data
 * @param name
 * @param index
 * @returns {{select: {itemStyle: {shadowBlur: number}}, data, selectedMode: boolean, name, itemStyle: {color: string}, type: string}}
 */
const buildSeries = (customAttr, data, name, index) => {
  const y = {
    name: name,
    type: 'bar',
    data,
    itemStyle: {
      color: hexColorToRGBA(customAttr.color.colors[index % customAttr.color.colors.length], customAttr.color.alpha)
    },
    selectedMode: true,
    select: BASE_ECHARTS_SELECT
  }

  // size
  if (customAttr.size) {
    if (customAttr.size.barDefault) {
      y.barWidth = null
      y.barGap = null
    } else {
      y.barWidth = customAttr.size.barWidth
      y.barGap = customAttr.size.barGap
    }
  }
  // label
  if (customAttr.label) {
    y.label = customAttr.label
  }
  return y;
}


/**
 * 根据选中的数值格式统一格式化处理数据
 * @param y
 * @param chart
 */
const formatValue = (y, chart) => {
  let yAxis = []
  try {
    yAxis = JSON.parse(chart.yaxis)
  } catch (err) {
    yAxis = JSON.parse(JSON.stringify(chart.yaxis))
  }
  const f = (yAxis && yAxis.length > 0) ? yAxis[0] : null
  if (f && f.formatterCfg) {
    // 不能添加千分符，否则数值无法正常渲染
    f.formatterCfg.thousandSeparator = false
    y.data.forEach(item => {
      if (!item.isFormat) {
        // 不在末尾添加千、万、亿等中文符号，否则数值无法正确渲染
        const v = valueFormatterWithoutSuffix(item.value, f.formatterCfg)
        item.value = v.includes('NaN') ? item.value : v
        item.isFormat = true
      }
    })
  }
}

export function barIncomeCompareOption(chart_option, chart) {
  baseBarOption(chart_option, chart)
  console.log("barIncomeCompareOption", chart_option, chart)
  return chart_option
}
